import { Reveal } from "./Reveal";

export default function OurStory() {
  return (
    <section
      id="our-story"
      className="scroll-mt-24 lg:scroll-mt-28 py-20 md:py-28"
      data-testid="our-story-section"
    >
      <div className="symp-container grid items-start gap-10 lg:grid-cols-[42fr_54fr] lg:gap-16">
        <Reveal className="lg:pt-10">
          <figure
            className="overflow-hidden rounded-[32px] shadow-[0_24px_60px_rgba(7,88,102,0.16)]"
            data-testid="founder-photo-wrap"
          >
            <img
              src="/images/founder.jpg"
              alt="Founder of SympTrack."
              className="aspect-[4/5] w-full object-cover"
              loading="lazy"
              data-testid="founder-photo"
            />
          </figure>
        </Reveal>
        <Reveal delay={100}>
          <h2 className="section-title text-brand-teal">Our Story</h2>
          <p
            className="mt-3 text-[28px] font-extrabold leading-[1.15] text-brand-coral md:text-[38px]"
            data-testid="our-story-statement"
          >
            I learned resilience early.
          </p>
          <div className="mt-6 space-y-5 text-[17px] font-medium leading-[1.65] text-brand-ink md:text-[19px]">
            <p>
              Growing up, I learned what it meant to keep going even when life
              was difficult, and that strength eventually carried me into
              healthcare.
            </p>
            <p>
              For years, I cared for people across different ages, backgrounds
              and care settings. Then chronic illness changed my perspective
              completely. I was no longer only the person helping care for
              patients. I became the patient who needed to be heard and
              understood too.
            </p>
            <p>
              Experiencing healthcare from both sides showed me something I
              could not ignore. So much of a person&rsquo;s health story
              happens outside the appointment, yet when it is finally time to
              sit with a provider, weeks or months of experiences can be
              incredibly difficult to explain.
            </p>
            <p>
              I created SympTrack because I believe those experiences deserve
              to remain part of the story.
            </p>
            <p className="font-extrabold text-brand-teal">
              Better understanding can change the conversation. And sometimes,
              a better conversation can change what comes next.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
